export default __webpack_public_path__ + "static/media/5.14e0fc16.jpg";